// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__29FIP","left":"InfoRow_left__3JMAp"};